import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import { getDocumentAICommandsBySessionId } from '@/pages/api/scribeAPIV2';
import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash-es';
import { useQueryTranscriptBySessionId } from './useQueryTranscriptBySessionId';

// paths
export const GET_DOCUMENT_AI_COMMANDS_BY_SESSION_ID = 'GetDocumentAICommandsBySessionID';

export function useQueryDocumentAICommandsBySessionId({
  sessionId,
  open,
  enabled,
}: {
  sessionId: string;
  open: boolean;
  enabled: boolean;
}) {
  const { isAuthenticated } = useIsAuthenticated();

  const { data: transcript } = useQueryTranscriptBySessionId(open ? sessionId : '');

  return useQuery({
    queryKey: [GET_DOCUMENT_AI_COMMANDS_BY_SESSION_ID, { sessionId }],
    enabled: isAuthenticated && open && !isEmpty(transcript?.transcript) && enabled,
    queryFn: async () => {
      const { data } = await getDocumentAICommandsBySessionId(sessionId);
      return data.ai_commands;
    },
  });
}
